// extracted by mini-css-extract-plugin
module.exports = {"container":"az_lcb"};